<template>
  <div>
    <flat-pickr v-model="localValue" :config="config" @on-change=""></flat-pickr>
  </div>
</template>

<script>
  import FlatPickr from 'vue-flatpickr-component';
  import 'flatpickr/dist/flatpickr.css';
  import weekSelect from 'flatpickr/dist/plugins/weekSelect/weekSelect'
  import customMixin from '@/mixins/customMixin'
  export default {
    name:'VbdatapickerWeek',
    props:{
      value: {
        type: String, 
			},
      
    },
    mixins : [customMixin],
    components: {
      FlatPickr
    },
    data: function(){
      return{
        localValue: this.value,
        config: {
          weekNumbers:true,
          dateFormat: 'Y-m-d',
          wrap: true,
          locale: { 
            firstDayOfWeek: 1,
            weekdays: {
              shorthand: this.shortHandDia(),
              longhand: this.longHandDia(),         
            }, 
            months: {
              shorthand:  this.shortHandMes(),
              longhand: this.longHandMes(),
            },
             weekAbbreviation: "Sm",
          },//locale
         
          plugins: [new weekSelect({})],
                  
        },   //config
        
      }//return
    },
    mounted(){
     //
    },
    watch:{
			localValue (newValue) {
		    this.$emit('input', newValue)
			},
			value (newValue) {
       	this.localValue = newValue
     	}
		},
    methods:{
      onChange(){ 
        if(this.week == true){
          const weekNumber = this.selectedDates[0]  ? this.config.getWeek(this.selectedDates[0]) : null;
        }
        

      }
    }
    
        
  }
</script>

<style lang="scss" scoped>

</style>